import slugify from 'react-slugify'

export const getButton = (isLogged, eventCategory, eventAction, eventLabel, dimension8 = null) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'event',
    'eventCategory': `${process.env.SKIN || 'webpremios'}:${eventCategory}-${isLogged ? 'logada' : 'aberta'}`,
    'eventAction': eventAction,
    'eventLabel': eventLabel,
    'dimension8': dimension8 ? slugify(dimension8, { delimiter: '-' }) : slugify((process.env.SKIN || 'webpremios'), { delimiter: '-' })
  })
}



// WEBPACK FOOTER //
// ./src/Shared/GTM/getButton.js